import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractFormControl } from '../abstract-form-control';
import { colorAsGradient, getContrastColor } from '@/utils/color-utils';

export const colorPresets = [
  '#000000',
  '#808080',
  '#FFFFFF',
  '#F44336',
  '#E91E63',
  '#9C27B0',
  '#673AB7',
  '#3F51B5',
  '#03A9F4',
  '#00BCD4',
  '#009688',
  '#36873a',
  '#4CAF50',
  '#8BC34A',
  '#CDDC39',
  '#FFEB3B',
  '#FFC107',
  '#FF9800',
  '#795548',
  '#607D8B',
];

function randomColorPreset(): string {
  return colorPresets[Math.floor(Math.random() * colorPresets.length)];
}

@Component({
  selector: 'wr-color-preset-picker',
  templateUrl: './color-preset-picker.component.html',
  styleUrls: ['./color-preset-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ColorPresetPickerComponent),
      multi: true,
    },
  ],
  standalone: false
})
export class ColorPresetPickerComponent extends AbstractFormControl<string> {
  protected readonly colorPresets = colorPresets;
  protected readonly getContrastColor = getContrastColor;

  setColor(color: string) {
    if (this.isDisabled) {
      return;
    }
    this.value = color;
  }

  protected readonly colorAsGradient = colorAsGradient;

  isPresetColor(color: string | undefined): boolean {
    if (color === undefined) {
      return false;
    }
    return this.colorPresets.includes(color);
  }

  editColor() {
    if (this.isPresetColor(this.value)) {
      return {
        color: 'default',
        background: 'transparent',
      };
    } else {
      return {
        color: getContrastColor(this.valueSignal()!),
        background: this.colorAsGradient(this.valueSignal()!),
      };
    }
  }

  override registerOnChange(fn: (value?: string) => void) {
    super.registerOnChange(fn);
    if (!this.value) {
      this.value = randomColorPreset();
    }
  }
}
